<template>
  <div class="row">
    <div class="col-2 b-form__container_min-width_200">
      <div>
        <label>{{$t('CONTENT.assets.lease_end_date')}}:</label>
        <datepicker class="b-datepicker" v-model="newEndDate" :formatter="datepickerFormat"></datepicker>
      </div>
    </div>
  </div>
</template>

<script>
import ChangePaymentEndDate from "../../models/commands/ChangePaymentEndDate";
import dateConverter from "@/utils/converters/date.converter";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  components: {},
  props: {
    paymentParams: {
      type: Object,
      required: true
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      newEndDateAsString: null
    };
  },
  computed: {
    newEndDate: {
      get() {
        if (this.newEndDateAsString === null) {
          return null;
        } else {
          return dateConverter.convertToDate(this.newEndDateAsString);
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.newEndDateAsString = dateConverter.convertToString(newVal);
        } else {
          this.newEndDateAsString = null;
        }
      }
    }
  },
  created() {
    this.newEndDateAsString = this.paymentParams.endDate;
  },
  methods: {
    cancel() {
      this.newEndDateAsString = this.paymentParams.endDate;
    },

    save() {
      const command = new ChangePaymentEndDate(
        this.paymentParams.idInDB,
        this.newEndDateAsString
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
